module.exports = __webpack_public_path__ + "img/39323e3fbf13e0ce35ca93581f31720.7e00236e.jpg";